'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import { ArrowRight, Check, FileSpreadsheet, FileText, Image as ImageIcon, Sparkles } from 'lucide-react'
import { useTranslations } from 'next-intl'
import '../../sass/landing/ImportAiSection.scss'

const importAiBullets = ['b1', 'b2', 'b3']

const ImportAiSection = () => {
  const t = useTranslations('LandingV2.importAi')

  return (
    <section id='import-ai' className='import-ai'>
      <div className='import-ai__container'>
        <motion.div
          className='import-ai__header'
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
        >
          <span className='landing-v2__chip'>{t('chip')}</span>
          <h2>{t('heading')}</h2>
          <p>{t('description')}</p>
        </motion.div>

        <motion.div
          className='import-ai__grid'
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className='import-ai__text'>
            <span className='import-ai__eyebrow'>
              <Sparkles size={14} /> {t('eyebrow')}
            </span>
            <ul className='import-ai__list'>
              {importAiBullets.map((id) => (
                <li key={id} className='import-ai__list-item'>
                  <Check size={16} /> {t(`bullets.${id}`)}
                </li>
              ))}
            </ul>
            <Link href='/login/signup' className='landing-v2__btn landing-v2__btn--accent import-ai__cta'>
              {t('cta')} <ArrowRight size={15} />
            </Link>
          </div>

          <div className='import-ai__visual'>
            <div className='import-ai__visual-glow' />
            <div className='import-ai__dropzone'>
              <div className='import-ai__formats'>
                <span className='import-ai__format-icon' aria-hidden='true'>
                  <ImageIcon size={22} />
                </span>
                <span className='import-ai__format-icon' aria-hidden='true'>
                  <FileText size={22} />
                </span>
                <span className='import-ai__format-icon' aria-hidden='true'>
                  <FileSpreadsheet size={22} />
                </span>
              </div>
              <div className='import-ai__dropzone-title'>{t('visualTitle')}</div>
              <div className='import-ai__dropzone-hint'>{t('visualHint')}</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default ImportAiSection
